// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fragment-tabs-view {
  height: 100%;
  background-color: #fff;
}
.fragment-tabs-view > .wui-tabs-bar {
  display: none;
}
.fragment-tabs-view > .wui-tabs-content {
  height: 100%;
}
.fragment-tabs-view > .wui-tabs-content > .wui-tabs-tabpane {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/runtime/views/TabsView.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;AACF;AAAE;EACE,aAAA;AAEJ;AACE;EACE,YAAA;AACJ;AACI;EACE,YAAA;AACN","sourcesContent":[".fragment-tabs-view {\n  height: 100%;\n  background-color: #fff;\n  &>.wui-tabs-bar {\n    display: none;\n  }\n\n  &>.wui-tabs-content {\n    height: 100%;\n\n    &>.wui-tabs-tabpane {\n      height: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
